import { useSelector } from "react-redux";

export const useTypedSelector = useSelector;
